"use client";

// LoyaBoost v1 simplification: no device-context dependency.
// Returns autoFocus as-is (no mobile/touch-aware logic yet).
// v2 can restore device-aware behaviour by re-adding DeviceContext.

import type { AutoFocusTarget } from "@/types";

export function useShouldAutoFocus(
  autoFocus: boolean = false,
  _target: AutoFocusTarget = "desktop",
): boolean {
  return autoFocus;
}
